<template>
  <b-form class="register-content" @submit="handleSubmit">
    <h3 v-bind:style="{ marginTop: '11px'}">Sign up to get started!</h3>
    <hr style="border-color: #000302; margin-top: 15px; margin-bottom: 20px"/>
    <b-form-group label="First Name" label-for="firstName">
      <b-form-input type="text" v-model="form.firstName" id="firstName" required></b-form-input>
    </b-form-group>
    <b-form-group label="Last Name" label-for="lastName">
      <b-form-input type="text" v-model="form.lastName" id="lastName" required></b-form-input>
    </b-form-group>
    <b-form-group label="Email" label-for="email">
      <b-form-input type="email" v-model="form.email" id="email" placeholder="you@example.com" required></b-form-input>
    </b-form-group>
    <b-form-group label="Password" label-for="password" description="Password must be at least 6 characters">
      <b-form-input type="password" v-model="form.password" id="password" required></b-form-input>
    </b-form-group>
    <b-form-group style="text-align: right;">
      <button :disabled="disabled" type="submit" class="btn arrow-btn-primary btn-inverse text-right" style="margin:5px 15px 5px 0px"><div>Start Application</div></button>
      <p class="text-right mt-2" v-if="isRegistering">Creating account...</p>
    </b-form-group>
  </b-form>
</template>

<script>
export default {
  name: 'Register',
  data () {
    return {
      isRegistering: false,
      form: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        accept: false
      }
    }
  },
  computed: {
    disabled: function () {
      if (this.form.firstName === '' ||
      this.form.lastName === '' ||
      this.form.email === '' ||
      this.form.password === '' ||
      this.form.password.length < 6 ||
      this.isRegistering) {
        return true
      }
      return false
    }
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.isRegistering = true
      this.$store.dispatch('user/register', this.form)
      .catch(err => {
        this.isRegistering = false
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/Auth.scss";
</style>



// WEBPACK FOOTER //
// src/components/user/Register.vue